import '@babel/polyfill';
import './assets/scss/main.scss';
import './directives/numbers-only';
import './directives/handle-zeros';
import './directives/click-outside';
import './directives/frame-resize';
import './directives/price-format';

import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Vue from 'vue';
import VueRouter from 'vue-router';

import { validationRules } from '@/services/custom-validation.ts';
import hashService from '@/services/hash-service';
import routesMethods, { routes } from '@/shared/routes';

import App from './App.vue';
import i18n from './plugins/i18n/i18n';
import userService from './services/user';
import { urls } from './shared/urls';

if (!routesMethods.isLoginPage() && !routesMethods.checkPage(urls.registration))
	userService.init();

hashService.init();

validationRules.init();

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(VueRouter);

Vue.config.productionTip = false;

const router = new VueRouter({ routes, mode: 'history' });

if (document.getElementById('vue-container')) {
	const requireComponent = require.context(
		'./pages/',
		false,
		/page-[^\\]*\.vue$/
	);
	requireComponent.keys()
		.forEach((fileName) => {
			const componentConfig = requireComponent(fileName);
			const componentName = upperFirst(
				camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
			);
			Vue.component(componentName, componentConfig.default || componentConfig);
		});

	new Vue({ el: '#vue-container', name: '', i18n });
}
else {
	new Vue({ name: '', render: (h) => h(App), i18n, router })
		.$mount('#app');
}


